<template>
  <div>
    <search
      :title="`${$t('modal.food')}`"
      :items="foods"
      idProperty="FoodId"
      nameProperty="FoodName"
      @triggerClick="triggerClick"
      @remove="remove"
      :searchItems="searchItems"
    />

    <food-select
      :isMultiple="true"
      :trigger="trigger"
      :defaultItems="defaultItems"
      @onSaved="add"
    />
  </div>
</template>

<script>
import search from "./Search";
import foodSelect from "@/components/selects/FoodSelects";

export default {
  data() {
    return {
      trigger: false,
      foods: [],
      defaultItems: undefined,
    };
  },
  props: {
    searchItems: {
      type: Object,
      default: () => ({}),
    },
  },
  watch: {
    searchItems(value) {
      if (JSON.parse(sessionStorage.getItem("isSamePage")) && value.Food) {
        this.foods = value.Food;
      }
    },
  },
  components: {
    search,
    foodSelect,
  },
  methods: {
    triggerClick() {
      this.defaultItems = [...this.foods];
      this.trigger = !this.trigger;
    },
    add(items) {
      this.foods = items;
      this.set();
    },
    remove(index) {
      if (!this.foods[index]) return;
      this.foods.splice(index, 1);
      this.set();
    },
    set() {
      this.$emit("set", this.foods);
    },
  },
};
</script>
